import { localize } from "locale"

export const templateRoles = [
  { value: "Publisher", name: localize("publisher") },
]
